'use strict';

function markdownLineEnding(code) {
  return code < -2;
}

module.exports = markdownLineEnding;